import { AddSongFacts, AddSongStep, isDraftSong, nextAddSongStep } from 'fym-shared/src/music24/catalogAddSong';
import { CatalogItemKind } from 'fym-shared/src/smartlinks/catalog';
import { CatalogItem } from '../../../../../redux/api/fymAPI.types';

/**
 * The facts of a catalog row that the "Add a song" flow reads (fym-shared `catalogAddSong.ts`).
 * A cover is an uploaded file or the snapshot url of a claim.
 */
export function addSongFactsOfItem(item: CatalogItem): AddSongFacts {
  return {
    kind: item.kind === CatalogItemKind.unreleased ? 'unreleased' : 'claimed',
    releaseDate: item.releaseDate !== null && item.releaseDate !== '' ? item.releaseDate : null,
    hasCover: item.artworkFile !== null || (item.artworkUrl !== null && item.artworkUrl !== ''),
    hasMaster: item.song.hasMaster,
    hasLyrics: item.song.hasLyrics,
  };
}

/** True for a song that has only its title so far (owner answer 1, 2026-10-09). */
export function isDraftItem(item: CatalogItem): boolean {
  return isDraftSong(addSongFactsOfItem(item));
}

/**
 * The step that "Finish setup" opens for a draft. Null for every other song: the list shows
 * "Finish setup" only on drafts, so it stays calm.
 */
export function draftFinishStep(item: CatalogItem): AddSongStep | null {
  const facts = addSongFactsOfItem(item);
  if (!isDraftSong(facts)) {
    return null;
  }
  const step = nextAddSongStep(facts);
  return step === 'done' ? null : step;
}
